import { render } from "./TariffCard.vue?vue&type=template&id=27fb3fc7&scoped=true"
import script from "./TariffCard.vue?vue&type=script&lang=js"
export * from "./TariffCard.vue?vue&type=script&lang=js"

import "./TariffCard.vue?vue&type=style&index=0&id=27fb3fc7&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/embody-system-front-student/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27fb3fc7"]])

export default __exports__